import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { PunchCardRedeem } from '../../models/punch-card-redeem';
import { PunchCard } from '../../models/punch-card';

import { BusinessPunchCardManagerHandler } from '../../providers/business-punch-card-handler';
import { BusinessPunchCardSequenceManagerHandler } from '../../providers/business-punch-card-sequence-handler';
import { ConsumerHandlerProvider } from '../../providers/consumer-handler';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-punch-card-redeem',
  templateUrl: 'business-punch-card-redeem.html',
})
export class BusinessPunchCardRedeemPage {
	punchCardRedeem: PunchCardRedeem;
  punchCard: PunchCard;
  sequences: any;
  customerInfo: any;
  scannedIds: any;
  hasSequences: boolean;
  filePath: any;
  loader: any;
  isLoading: boolean = false;
  isPunching: boolean = false;

	private punchCardRedeemForm : FormGroup;
  punchRefreshDone: boolean = false;
  leftView: boolean = false;
  previousPunchCount: any = 0;
  punchItemGeneratedCount: any = 0;
  currentMasterId: any = '';
  punchCardSummary: any = 'Punch card summary';
  isPunched: boolean = false;
  
  consumerData: any; 

  constructor(
  	public navCtrl: NavController, 
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,    
    public consumerHandlerProvider: ConsumerHandlerProvider,
    public punchCardManagerHandler: BusinessPunchCardManagerHandler,
    public punchCardSequenceManagerHandler: BusinessPunchCardSequenceManagerHandler,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public globals: Globals,
    public actionSheetCtrl: ActionSheetController) {
  	
  	this.customerInfo = navParams.get('punchCardRedeem');
   
    this.punchCardRedeem = {
      PunchCardId: this.customerInfo[0],
      UserId: this.customerInfo[1]
    };
    
    this.consumerHandlerProvider.currentIdentityUserId = this.punchCardRedeem.UserId;

    this.isLoading = true;

    try{
      var idArr = this.punchCardRedeem.PunchCardId.split("-");

      if(idArr.length<=1){
        this.showError("This is not a punch card");

        this.isLoading = false; 

        this.navCtrl.pop();          
      }else{
        this.loadPunchCard()    
      }
    }catch(e){}    
  }

  loadPunchCard(){
    console.log('loadpunchcard userid: ' + this.punchCardRedeem.UserId);
    console.log('loadpunchcard PunchCardId: ' + this.punchCardRedeem.PunchCardId);  

    this.punchCardManagerHandler.getPunchCardUser({
      punchCardId: this.punchCardRedeem.PunchCardId,
      userId: this.punchCardRedeem.UserId,
      cb:(result)=>{
          console.log("HOLA I AM IN CALLBACK");
          console.log(result);

        if(result.Success){
          if(!this.punchRefreshDone){
            this.isLoading = false;      
          }     

          this.prepCard(result.Data);  

        } else {
            this.showError(result.Message)

            this.isLoading = false; 

            this.navCtrl.pop();
        }
        
      }
    })
  }

  showError(errorMsg){
    let alert = this.alertCtrl.create({
      title: 'Error',
      subTitle: errorMsg,
      buttons: ['Ok']
    });

    alert.present();    
  }

  punchThatCard(){
    if(this.isPunching) return;
    
    this.isPunching = true;

    this.punchCardSequenceManagerHandler.punchUserCard({
      PunchCardId: this.punchCardRedeem.PunchCardId,
      UserId: this.punchCardRedeem.UserId,
      TransactionAmount: "0",
      cb:(result)=>{
        if(result.Success){
            let alert = this.alertCtrl.create({
              title: 'Success',
              subTitle: 'Card has been punched!',
              buttons: ['Ok']
            });

            alert.present();

            this.loadPunchCard()

            this.isPunched = true

            this.isPunching = false;
        } else {

           let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: result.Message,
              buttons: ['Ok']
            });

            alert.present();
        }
      }
    })

  }

  prepCard(result){
    if(this.currentMasterId != result.punchCardSequenceList[0].MasterId && this.currentMasterId!=''){
      this.previousPunchCount = 0;
    }

    this.currentMasterId = result.punchCardSequenceList[0].MasterId;

      if(
        this.previousPunchCount < result.punchCardSequenceList[0].TotalNeededPunches 
        || 
        this.previousPunchCount == 0
      ){
        this.punchItemGeneratedCount = 0;

        this.punchCard = result.punchCard;

        this.sequences = result.punchCardSequenceList;
        
        this.configureSequence();

        this.filePath = this.globals.fileUrl + this.punchCard.ImagePath;

        this.hasSequences = this.sequences.length > 0;

        if(this.hasSequences){
        this.alertUserForNewPunch();

          this.previousPunchCount = this.getTotalUserPunchSum();  
        }           
      }    
  }

  getTotalUserPunchSum(){
    var returnVal = 0;

    for (var i = this.sequences.length - 1; i >= 0; i--) {
      returnVal += this.sequences[i].TotalUserPunches
    }

    return returnVal;
  }

  alertUserForNewPunch(){
    if(this.previousPunchCount < this.getTotalUserPunchSum() && this.punchRefreshDone == true){
      let alert = this.alertCtrl.create({
        title: 'Card stamped',
        subTitle: 'You stamped this card. Keep at it to win awesome stuff!',
        buttons: ['Ok']
      });

      alert.present();    
    }
  }

  configureSequence(){
    var sequencePunchSum = 0;
    var totalPunches = 0;

    //Setup punches
    for (var i = 0; i < this.sequences.length; i++) {
      let sequence = this.sequences[i];

      sequence.punches = this.createPunchArray(
        sequence.PunchQuantity, 
        sequence.TotalUserPunches, 
        sequence.PunchCardSequenceId
      )

      //Mark sequences as done
      sequence.punchesLeft = (sequence.PunchQuantity > sequence.TotalUserPunches) ? true : false;
      sequencePunchSum+= sequence.TotalUserPunches;

      totalPunches = sequence.TotalNeededPunches;
    }

    this.punchCardSummary = sequencePunchSum + " punches of " + totalPunches + " done.";
  }

  createPunchArray(sequencePunchQuantity, sequenceUserPunchCount, id){
    var punches = [];

    for (var i = 0; i < sequencePunchQuantity; i++) { 
        punches.push({
            id: i + 1,
            punched: (sequenceUserPunchCount>=i+1) ? true : false
        });
    }  

    return punches;  
  }

  calcRemainingPunchesToReward(qty){
    return qty - this.previousPunchCount;
  }

  cancelPunchCardRedeem(){
    this.navCtrl.pop();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessPunchCardRedeemPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-punch-card-redeem/business-punch-card-redeem.ts